import MonitoringContent from './components/MonitoringContent'

function MonitoringIndexPage() {
  return <MonitoringContent />
}

export default MonitoringIndexPage
